export default __webpack_public_path__ + "static/img2-aaad11b03a4c5d337aae29568dcf680b.jpg";